import request from 'sb-request'
import { reducers } from 'redux/core'

// import mock from './mock'


const productSlug = 1270

const fetch = () =>
  request.get(`rest/product?slug=${productSlug}&detailed=true`, {
    modifyResult: (data) => {
      let { media = [], price = 0, priceWithDiscount = 0, giftsetItems = [] } = (data || {})

      // remove 1st image (product) form slider
      media = media
        .slice(1)
        .map(({ preview }) => preview)

      giftsetItems = giftsetItems.map(({ id, name, brand, description, rating, img, price }) => ({
        id,
        name,
        brand,
        description,
        rating,
        image: img,
        price,
      }))

      const discount = price - priceWithDiscount

      return {
        ...data,
        media,
        discount,
        giftsetItems,
      }
    },
  })
    .then((result) => {
      reducers.view.fathersDayGiftSetPage.set(result)

      return result
    })


export default {
  fetch,
}
